module.exports = __webpack_public_path__ + "static/media/CollegeTuition.769612eb.jpg";